export const perSessionBannersKey = 'perSessionBanners';

export const perSessionFetchBannersKey = 'perSessionFetchBanners';

export const perSessionModalKey = 'perSessionModalKey';

export const perSessionAchCompletionTimeKey = 'perSessionAchCompletionTimeKey';

export const perSessionAchValidateSuccessKey = 'perSessionAchValidateSuccessKey';

export const perSessionTermAgreedKey = 'perSessionTermAgreedKey';

export const perSessionAchDiscountModalM0 = 'achDiscountModalM0';

export const perSessionAchDiscountModalM2 = 'achDiscountModalM2';

export const perSessionAuthCopyAckModal = 'authCopyAckModal';

export const perSessionPreInstallationCompleteModal = 'perSessionPreInstallationCompleteModal';

export const perSessionInstallationCompleteModal = 'perSessionInstallationCompleteModal';

export const perSessionSystemActivationCompleteModal = 'perSessionSystemActivationCompleteModal';

export const perSessionOnboardingBannerKey = 'perSessionOnboardingBannerKey';

export const perSessionMyEverBrightBannerKey = 'perSessionMyEverBrightBanner';

export const PER_SESSION_STORAGE_KEYS = [
  perSessionAchCompletionTimeKey,
  perSessionAchDiscountModalM0,
  perSessionAchDiscountModalM2,
  perSessionBannersKey,
  perSessionFetchBannersKey,
  perSessionInstallationCompleteModal,
  perSessionModalKey,
  perSessionMyEverBrightBannerKey,
  perSessionOnboardingBannerKey,
  perSessionPreInstallationCompleteModal,
  perSessionSystemActivationCompleteModal,
];

export const authenticatedKey = 'authenticated';

// perSessionAutopayBanner is a function because we want a unique key per agreement
export const perSessionAutopayBannerKey = (id: string) => `perSessionAutopayBannerKey-${id}`;
